/**
 * @param {string} html
 * @param {string} classList
 */
function makeMessageElement(html, classList = '') {
  const $el = document.createElement('div');
  $el.setAttribute('class', classList);

  $el.innerHTML = html;

  return $el;
}


class Messenger {
  /**
   * @param {Element} $messageContainer
   */
  constructor($messageContainer) {
    this.$messageContainer = $messageContainer;
  }

  /** @param {string} message */
  addSuccessMessage(message) {
    return this.addMessage(message, 'alert alert-success');
  }

  /** @param {string} message */
  addInfoMessage(message) {
    return this.addMessage(message, 'alert alert-info');
  }

  /** @param {string} message */
  addErrorMessage(message) {
    return this.addMessage(message, 'alert alert-danger');
  }

  /** @param {string} message */
  addWarningMessage(message) {
    return this.addMessage(message, 'alert alert-warning');
  }

  /**
   * @param {string} message
   * @param {string} classList
   */
  addMessage(message, classList = 'alert') {
    const $el = makeMessageElement(message, classList);

    this.$messageContainer.appendChild($el);

    return $el;
  }

  clearMessages() {
    this.$messageContainer.innerHTML = '';
  }
}


export default Messenger;



// WEBPACK FOOTER //
// ./V7/tnew/ui/Messenger.js